import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFunctions } from "firebase/functions";

// NOTE: we no longer import getAnalytics/logEvent at top level
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const functions = getFunctions(app);

let analyticsInstance = null;

export async function enableAnalytics() {
  console.log("[Analytics] enableAnalytics() called");

  if (analyticsInstance) {
    console.log("[Analytics] already initialized:", analyticsInstance);
    return analyticsInstance;
  }

  // Lift the disable flag so gtag can fire
  const disableFlag = `ga-disable-${process.env.REACT_APP_FIREBASE_MEASUREMENT_ID}`;
  window[disableFlag] = false;
  console.log(`[Analytics] ${disableFlag} set to false`);

  // Dynamically import the analytics functions
  const analyticsModule = await import("firebase/analytics");
  console.log("[Analytics] imported firebase/analytics module:", analyticsModule);

  // Initialize & store
  analyticsInstance = analyticsModule.getAnalytics(app);
  console.log("[Analytics] analyticsInstance created:", analyticsInstance);

  analyticsModule.logEvent(analyticsInstance, "page_view");
  console.log("[Analytics] page_view event sent");

  return analyticsInstance;
}

// export analyticsInstance if you need to inspect it elsewhere
export { analyticsInstance };
